export default {
  auto: 'Auto',
  signals: 'Signale',
  axes: 'Achsen',
  axesHeader: {
    displayName: 'Achsenbeschriftung',
    chartScaleType: 'Achsentyp',
    position: 'Achsenposition',
    limitMin: 'Untere Grenze',
    limitMax: 'Obere Grenze',
    defaultUnitOfMeasure: 'Maßeinheit',
    signalCount: 'Anzahl der Signale',
    delete: '',
  },
  deleteAxisConfirmation: {
    title: 'Achse löschen',
    message: 'Diese Achse enthält {count} Signal(e). Alle diese Signale werden ebenfalls gelöscht. Möchten Sie die Achse wirklich löschen?',
  },
};
